// @flow

import * as React from 'react'
import { Label, Segment, Message } from 'semantic-ui-react'
import { connect, type Connector } from 'react-redux'

import VisitsDetailsReport from './visits-details-report'
import CalendarReport from './calendar-report'
import TemporalSeries from './temporal-series'
import CampaignsDropdown from '../systemwide/allowed-campaigns-dropdown'
import { getDailyAggregatedData } from '../store/reports'

import type { ReduxState, Dispatch } from '../store'

type OwnProps = {|
  reportType: string,
|}

type MappedProps = {|
  currentCampaign: string,
  campaignFromRoute: boolean,
|}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps): MappedProps => {
  return {
    currentCampaign: state.allowedCampaigns.currentCampaign,
    campaignFromRoute: 'campaignName' in state.location.payload,
  }
}

type Props = { dispatch: Dispatch } & OwnProps & MappedProps
class ReportsPage extends React.Component<Props> {
  static defaultProps = {}

  componentDidUpdate(newProps) {
    if (
      newProps.reportType !== 'details' &&
      this.props.currentCampaign &&
      this.props.currentCampaign !== newProps.currentCampaign
    ) {
      this.props.dispatch(getDailyAggregatedData(this.props.currentCampaign))
    }
  }

  render() {
    let title = ''
    let child = <span />
    switch (this.props.reportType) {
      case 'details':
        title = 'Dettaglio visite'
        child = <VisitsDetailsReport />
        break
      case 'calendar':
        title = 'Calendario visite'
        child = <CalendarReport />
        break
      case 'chart':
        title = 'Andamento temporale'
        child = <TemporalSeries />
        break
      default:
        title = ''
    }

    return (
      <div style={{ height: '100vh', paddingTop: '9ex' }}>
        {this.props.currentCampaign === '' && (
          <Message
            style={{
              marginTop: '40vh',
              marginLeft: '33vw',
              position: 'absolute',
              zIndex: '1000',
              width: '33vw',
              textAlign: 'center',
            }}
            floating
            info>
            <Message.Header>{title}</Message.Header>
            <p>Selezionare una campagna dal menù a tendina in alto a destra</p>
          </Message>
        )}
        <Segment
          padded={false}
          secondary
          style={{ margin: '0 3ex 0 3ex', height: '90vh', display: 'flex', flexDirection: 'column' }}>
          <Label attached="top" color="blue" size="small" style={{ zIndex: '710', width: '100%' }}>
            <div style={{ fontSize: '1.285rem', paddingTop: '.63ex', float: 'left' }}>{title}</div>
            {this.props.campaignFromRoute && (
              <div style={{ float: 'right', height: '2rem' }}>
                <span style={{ marginRight: '1ex', fontSize: '1.285rem', paddingTop: '.63ex', float: 'left' }}>
                  {this.props.currentCampaign}
                </span>
              </div>
            )}
            {!this.props.campaignFromRoute && (
              <div style={{ float: 'right' }}>
                <span style={{ marginRight: '1ex', fontSize: '1.285rem', paddingTop: '.63ex', float: 'left' }}>
                  Seleziona campagna:
                </span>
                <CampaignsDropdown style={{ minWidth: '40ex' }} />
              </div>
            )}
          </Label>

          {child}
        </Segment>
      </div>
    )
  }
}

const connector: Connector<OwnProps, MappedProps> = connect(mapStateToProps, null)
export default connector(ReportsPage)



// WEBPACK FOOTER //
// ./src/reports/reports-page.js